import { render } from "./PicoG2.vue?vue&type=template&id=32625194&ts=true"
import script from "./PicoG2.ts?vue&type=script&lang=ts&external"
export * from "./PicoG2.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__